import { ApiError } from 'types/errorTypes';

export const toApiError = (error: unknown): ApiError =>
  typeof error === 'object' && error !== null ? (error as ApiError) : {};
